export default async function getNotiCount(): Promise<number> {
  try {
    const response = await fetch('/api/get-notification-count');
    if (!response.ok) {
      throw new Error('Error fetching user data');
    }
    const notiCount = await response.json();
    return notiCount;
  } catch (e) {
    return 0;
  }
}
